export default {
   'Search': 'Suche',
   'User': 'Benutzer',
   'Users': 'Benutzer',
   'Email': 'E-Mail',
   'Phone Number': 'Telefonnummer',
   'Address': 'Adresse',
   'Company login': 'login',
   "Permission" : "Erlaubnis",
   "All Users" : "Alle Nutzen",
   'Learning' : "Lernen",
   "Loading Course Data..." : "Kursdaten werden geladen...",
   "Send Message to Group/Users" : "Nachricht an Gruppe/Benutzer senden",

 /****************** Navbar *************/
    'Logout': 'abmelden',
    'Profile': 'Profil',
    'Invoices':'Rechnungen',
 /******************  Datatable ***********/
   'Title': 'Name',
   'Version': 'Version',
   'Module Slug': 'Modul',
   'Progress': 'Fortschritt',
   'Attempted on': 'am',
   'Score':'Punkte',
   'Your Quizes':'Quiz',
   'Launch':'Start',
   'Jump To Quiz': 'Zum Test springen',
   'Rows per page': 'Einträge pro Seite',
   "There is no Quiz to show" : "Es gibt kein anzuzeigendes Quiz",
   "There is no Data to show" : "Es sind keine Daten zum Anzeigen vorhanden",
   
 /****************** Users ***********/

   "Subscribed Courses" : "Abonnierte Kurse",
   "Un-Subscribed Courses" : "Abgemeldete Kurse",

   'Name': 'Name',
   'Actions': 'Aktionen',
   'Image' : 'Bild',
   'Salutation': 'Anrede',
   'Invite Users': 'Benutzer einladen',
   'Date of birth': 'Geburtsdatum',
   'All cards': 'alle Karten',
   'Card added successfully':'Karte erfolgreich hinzugefügt',
   'Remove' :'entfernen',
   'User Profile': 'Benutzer Profil',
   'All Cards': 'Alle Kurse',
   'Add Card' : 'Kurs hinzufügen',
   'Primary': 'Primäre Farbe',
   'Are you sure want to remove?': 'Wirklich entfernen?',
   'Subscribe' : 'teilnehmen',
   'Are you sure you want to purchase?':'Jetzt kaufen?',
   'Yes':'Ja',
   'No':'Nein',
   'Role' : 'Rolle',
   'You dont seem to have a card added to your profile':'Keine Zahlungsart hinterlegt',
   'Go to profile':'Kreditkarte hinterlegen',
   "Place of birth": "Geburtsort",
   "Allow registration" : "Anmeldung zulassen",
   "Allowed Email Domains" : "Zulässige E-Mail-Domänen",
   "No data to show" : "Keine Daten zum Anzeigen",

 /****************** Courses ***********/
   'Filters':'Filter',
   'Details': 'zum Modul',
   'Purchased': 'gekauft',
   'Included' : 'inklusive',
   'What Will you Learn?': 'Lerninhalte',
   'Requirements' : 'Voraussetzungen',
   'Glossary' : 'Glossar',
   'Description' : 'Beschreibung',
   'PLAY NOW': 'jetzt starten',
   'Language': 'Sprache',
   "Created On:" : "Erstellt am:",
   "Course Subscription Ends On:" : "Das Kursabonnement endet am:",

   'Close': 'Schließen',
   'Upload': 'Hochladen',
   'Submit': 'Absenden',
   'User csv file': 'Benutzer CSV Datei',
   'Module name here': 'Hier Kursnamen eintragen',
   'Subscription': 'Abo',
   'Languages': 'Sprachen',
   'Module': 'Modul',
   'Subject': 'Betreff',
   'Body': 'Nachricht',
   'Send copy to myself' : 'Eine Kopie an mich senden',
   'Contact us': 'Nimm Kontakt auf',
   'Status': 'Status',
   'Join date': 'Beitrittsdatum',
   'Last login' : 'Letzte Anmeldung',
   'Change status': 'Status ändern',
   'Active': 'aktiv',
   'active': 'aktiv',
   'Inactive':'inaktiv',
   'inactive':'inaktiv',
   'disable': 'deaktivieren',
   'pending': 'Inaktiv',
   'Pending': 'Inaktiv',
   'Subscribed':'eingeschrieben',
   'Unsubscribed':'nicht eingeschrieben',
   'English':'Englisch',
   'German':'Deutsch',
   'User updated successfully': 'Benutzer erfolgreich aktualisiert',
   'User created successfully': 'Benutzer erfolgreich erstellt',

   'Modules': 'Module',
   'Your Modules': 'Deine Module',

   'No modules found': 'Keine Module gefunden',
   'Course':'Kurse',
   'Your attempted modules': 'Deine Modul Versuche',
   'No data found': 'keine Daten gefunden',
   'Time Spent' : 'Verbrachte Zeit',
   'From': 'Absender',
   'To': 'bis zum',
   'Play':'abspielen',  
   'Your sessions': 'Deine Sessions',
   'Your attempts': 'Deine Versuche',    
   'Settings': 'Einstellungen',
   'View': 'ansehen',
   'Roles': 'Rollen',
   'Group': 'Gruppe',   
   'Comment (optional)': 'Kommentar (optional)',
   'Due date': 'gültig bis',
   'Select file': 'Dokument aussuchen',
   'Days until': 'Tage gültig',
   'Template' : 'Vorlage',
   'Update': 'Update',
   'Edit': 'Editieren', 
   'Uploaded by': 'hochgeladen von',  
   'Uploaded on': 'hochgeladen am',
   'Type':'Typ',
   'Action':'Aktion',
   'Stage 1': 'Bereich 1',
   'Stage 2': 'Bereich 2',
   'Set Name': 'Name',
   'Show next': 'zeige die nächsten x Tage',
   'Show from':'zeige die darauffolgenden nächsten x Tage',   
   'Name is required': 'Name wird benötigt',
   'Invalid Email address': 'Keine gültige E-Mail Adresse',
   'Phone Number is required': 'Es wird eine Telefonnummer benötigt',
   'Disable user?: Yes' : 'Benutzer deaktivieren?: Ja',
   'Disable user?: No' : 'Benutzer deaktivieren?: Nein',
   'Disable from' : 'Deaktivieren von',
   'Salutation is required':'Ansprache wird benötigt',
   'Address is required': 'Adresse wird benötigt',
   'Group admin is required':'Gruppen Admin muss erstellt werden',
   'Groups are required': 'Gruppen werden benötigt',
   'Status is required': 'Status wird benötigt',
   'Mr': 'Herr',
   'Mrs':'Frau',  
   'Set Filter':'Filter setzen',
   'Location':'Ort',
   'Procedure': 'Prozedur',
   'Class':'Klasse',
   'Maker':'Hersteller',
   'Serial maker': 'Hersteller',
   'Stock':'Lager',
   'Good until date': 'gültig bis',
   'Equipment':'Ausstattung',
   'Equipment created successfully':'Equipment erfolgreich angelegt',
   'Equipment updated successfully':'Equipment erfolgreich ge-updated',
   'Equipment Group':'Ausrüstungsgruppe',
   'Add Equipment Group': 'Ausrüstungsgruppe hinzufügen',
   'Edit Equipment Group': 'Ausrüstungsgruppe ändern',
   'Equipment group name': 'Ausrüstungsgruppenname',
   'Equipment group name is required': 'Ausrüstungsgruppenname is notwendig',
   'Equipment group added successfully': 'Ausrüstungsgruppe erfolgreich hinzugefügt',
   'Equipment group updated successfully': 'Ausrüstungsgruppe erfolgreich geändert',
   'Company Admin' : 'Firmenadministrator',
   'Tester' : 'Tester',
   'Auditor' : 'Auditor',
   'External User' : 'Externer Benutzer',
   'user' : 'Benutzer',
   'group-admin' : 'Gruppen Administratoren',
   'company-admin' : 'Firmenadministrator',
   'external-user' : 'Externer Benutzer',
   'tester' : 'Tester',
   "UserInvitationMail" : "UserInvitationMail (Sendet eine Einladungsmail an den Benutzer)",
   "ExternalUserInvitationMail"  : "ExternalUserInvitationMail (Sendet Einladungsmail an externen Benutzer)",
   "ContactUsMail" : "ContactUsMail (Sendet eine direkte Nachricht an den Benutzer)",
   "ContactUsSendCopyMail" : "ContactUsSendCopyMail (Sendet eine Kopie der Direktnachricht an sich selbst)",
   "DailyStatsMail" : "DailyStatsMail (Tägliche Statistik-Mail)",
   "InstructorBookingMail" : "InstructorBookingMail (Buchungsmail für einen Dozenten)",
   "UserBookingMail" : "UserBookingMail (Bestätigungsmail der Buchung an einen Benutzer)",
   "UserInvitationCourseCouponCodeMail" : "UserInvitationCourseCouponCodeMail (Benutzer-Einladungsmail zusammen mit Kursgutscheincode)",
   "UserInvitationTutorProductCouponCodeMail" : "UserInvitationTutorProductCouponCodeMail (Benutzer-Einladungsmail zusammen mit Gutscheincode für Tutor-Produkte)",
   "CourseCouponCodeMail" : "CourseCouponCodeMail (Mail mit Kursgutscheincode)",
   "CourseCertificateMail" : "CourseCertificateMail (Sendet eine E-Mail mit dem Kurszertifikat an den Benutzer)",
   "TutorProductCouponCodeMail" : "TutorProductCouponCodeMail (E-Mail mit dem Gutscheincode für Tutor-Produkte)",
   "TwoFactorAuthCodeMail" : "TwoFactorAuthCodeMail (Zwei-Faktor-Authentifizierungsmail an Benutzer)",
   "PasswordResetRequestMail" : "PasswordResetRequestMail (E-Mail zum Zurücksetzen des Passworts)",
   "PasswordResetSuccessMail": "PasswordResetSuccessMail (Erfolgsmail für Passwortzurücksetzungen)",

   'Add Equipment Template': 'Kalibrationsvorlage hinzufügen',
   'Edit Equipment Template': 'Kalibrationsvorlage ändern',
   'Equipment template added successfully': 'Kalibrationsvorlage erfolgreich hinzugefügt',
   'Equipment template updated successfully':'Kalibrationsvorlage erfolgreich geändert',
   'Equipment name':'Name des Ausrüstungsgegenstandes',
   'Add Items':'Ausrüstungsgegenstand hinzufügen',
   'Edit Items':'Ausrüstungsgegenstand ändern',
   'Equipment image':'Bild des Ausrüstungsgegenstands',
   'Equipment templates':'Kalibrationsvorlagen',
   'Equipment template name':'Kalibrationsvorlagenname',  
   'Equipment group':'Ausrüstungsgruppe',
   'Equipment group is required': 'Ausrüstungsgruppe wird benötigt',
   'Equipment groups': 'Ausrüstungsgruppen',
   'Equipment template': 'Kalibrationsvorlage',
   'Equipment template id': 'Kalibrationsvorlagen ID' , 
   'Equipment Template':'Kalibrationsvorlage',
   'Items': 'Ausrüstungsgegenstände',
   'Number in stock': 'Lagerbestand',
   'Location is required':'Der Ort wird benötigt',
   'Class is required':'Klasse wird benötigt',
   'Maker is required':'Hersteller wird benötigt',
   'Number in stock is required':'Lagerbestand wird benötigt',
   'Goods until date is required':'Gültig bis wird benötigt',
   'Procedure is required':'Prozedur wird benötigt',
   'Description is required':'Beschreibung wird benötigt',
   'Group name': 'Gruppen-Name',
   'Group admins': 'Gruppen Administratoren',
   'Group name is required':'Gruppen-Name wird benötigt',
   'Users are required': 'Benutzer werden benötigt',
   'Course are required':'Kurse werden benötigt',
   'Company settings': 'Firmeneinstellungen',
   'Company Color': 'Firmen Primärfarbe',
   'Session login time': 'Login Zeit',
   'Select TimeZone' : 'Wähle Zeitzone aus',
   'Please Select Timezone for the Company' : 'Bitte wählen Sie die Zeitzone für das Unternehmen aus',
   'Daily Quiz Settings' : "Tägliche Quiz-Einstellungen",
   'Number of Questions' : 'Anzahl der Fragen',
   'Passing Percentage' : 'Durchgangsprozentsatz',
   'America/Chicago' : 'Amerika/Chicago',
   'Europe/Berlin' : 'Europa/Berlin',
   'Asia/Kolkata' : 'Asien/Kalkata',
   'Quiz Score History' : 'Bisherige Versuche',
   
   'Primary color is required':'Farbe kann nicht leer sein',
   'Company settings updated successfully':'Firmeneinstellungen erfolgreich geändert',
   'Intellectual Property Rights':'Rechte an geistigen Eigentum',
   'Unless otherwise indicated, the Site and all source code, database, functionality, software, website designs, audio, video, text, photographs, and other learning material on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (collectively, the “Marks”) are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of Germany, foreign jurisdictions, and international conventions.': 'Sofern nicht anders angegeben, sind die Website und alle Quellcodes, Datenbanken, Funktionen, Software, Website-Designs, Audio-, Video-, Text-, Foto- und sonstigen Lernmaterialien auf der Website (zusammen der „Inhalt“) sowie die Marken, Dienstleistungsmarken, und darin enthaltene Logos (zusammen die „Marken“)  durch Urheber- und Markenrechte sowie verschiedene durch andere Rechte an geistigem Eigentum und an den Gesetzen gegen unlauteren Wettbewerb in Deutschland, ausländischen Gerichtsbarkeiten und internationalen Konventionen geschützt.',
   'I accept this (required)': 'Ich akzeptiere das (erforderlich)',
   'Please subscribe to a course': 'Bitte melden Sie sich zu einem Kurs an',
   'Your score': 'Erreichte Punkte',
   'Go to courses': 'Zu den Kursen',
   'Max Score' : 'Maximale Punkte',
   'Time taken':'Verbrachte Zeit',
   'Pass Score':'Benötigte Punkte',
   'No subscribed courses found':'Sie sind noch keinem Kurs beigetreten',   
   'Role is required':'Rolle wird benötigt',
   'Confirm Password is required':'Bitte bestätigen Sie das Passwort',
   'Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character -#?!@$%^&*_': 'Das Passwort muss eine Länge von 8 Zeichen haben und mindestens 1 Großbuchstaben, 1 Kleinbuchstaben, 1 Zahl und 1 Sonderzeichen enthalten.',
   'Password must be at least 8 characters long': 'Das Passwort muss mindestens 8 Zeichen lang sein',
   'Confirm Password must be at least 8 characters long' : 'Das Passwort muss mindestens 8 Zeichen lang sein',
   'Confirm Password must contain 1 Uppercase, 1 Lowercase, 1 Numeric and 1 special character -#?!@$%^&*_': 'Das Passwort muss eine Länge von 8 Zeichen haben und mindestens 1 Großbuchstaben, 1 Kleinbuchstaben, 1 Zahl und 1 Sonderzeichen enthalten.',   
   'Query successfully sent': 'Erfolgreich gesendet',
   'Dashboard': 'Dashboard',
   'Courses': 'Kurse',
   'Powered by Evaluation Experts': 'Powered by Evaluation Experts',
   'Check':'filtern',
   'Clear': 'löschen',
   'Groups': 'Gruppen',
   'Inbox': 'Posteingang',
   'Board': 'Das Board',
   'No data available': 'Keine Einträge gefunden.',
   'Company color': 'Firmen Primärfarbe',
   'Learning material': 'Lernmaterial',
   'Search learning material': 'Lernmaterial durchsuchen',
   'Learning material updated successfully':'erfolgreich akutalisiert',
   'Learning material are required':'Lernmaterial wird benötigt',
   'Learning material name':'Lernmaterial Name',
   'Update Password': 'Passwort aktualisieren',
   'This password reset token is invalid': 'Bitte kontaktieren Sie ihren Admin, Ihr Link ist abgelaufen.',
   'Password is required':'Passwort ist notwendig',   
   'Accept & Continue': 'Akzeptieren und weiter',
   'Due days is required':'Due Date wird benötigt',
   'Learn NDT': 'Learn NDT',
   'Username':'Name',
   'Password':'Passwort',
   'Forgot password': 'Passwort vergessen',
   'Register':'Registrieren',
   'Login':'Login',   
   'Username is required': 'Name wird benötigt',
   'Phone is required':'Telefonnummer wird benötigt',
   'User registeration successfully': 'Benutzer erfolgreich registriert',
   'Company Admin Login': 'Login',
   'Go to Login': 'zum Login',
   'Send link':'Link senden',
   'No user documents':'keine Benutzer-Dokumente',
   'User documents':'Dokumente',
   'Update user documents' : 'Nutzer-Dokument aktualisieren',
   'Edit user documents': 'Nutzer-Dokumente editieren',
   'Module details': 'Modul Details',
   'passed':'bestanden',
   'Passed':'Bestanden',
   'failed':'nicht bestanden',  
   'of':'von',
   'Create user documents':'Benutzer Dokument erstellen',
   'Passwords must match': 'Wiederholen Sie aus Sicherheitsgründen das oben genannte Passwort.',
   'attempted': 'versucht',
   'Progress & Attempts': 'Fortschritt & Versuche',
   'Attempted': 'versucht',
   'Attempts': 'Versuche',
   'Save': 'speichern',
   'Details new': 'öffnen',
   'Profile updated successfully': 'Profil erfolgreich aktualisiert',
   'User document name': 'Name des Dokuments',
   'Group created successfully': 'Gruppe erfolgreich erstellt',
   'Group updated successfully': 'Gruppe erfolgreich aktualisiert',
   'User document updated successfully':'Benutzer Document erfolgreich aktualisiert',
   'Registration status changed successfully': 'Status erfolgreich aktualisiert',
   'Write to Company Representative': 'Ich habe eine Frage',
   'Welcome to the learning-material section. After passing a course you will see additional learn-material appear here.':'Herzlich Willkommen im Bereich Lernmaterial. Sobald Sie einen Kurs erfolgreich absolviert haben, können Sie die Lernmaterialien hier erneut nutzen.',
   'No Learning material found':'Es wurde kein Lernmaterial gefunden.',
   'OK':'OK',
   'Cancel': 'abbrechen',
   'Body is required':'Nachricht wird benötigt.',
   'Subject is required':'Titel wird benötigt',
   'Undefined':'Allgemein',
   'Copyright legal notice':'Copyright',
   'Please upload a file':'Bitte wählen Sie eine gültige Datei aus.',
   'The value must be an integer number':'Bitte tragen Sie eine Telefonnummer ein.',
   'Date is required': 'Datum wird benötigt',
   'Session minutes is required':'Minuten werden benötigt',
   '& others':'& weitere',
   'Continue':'WEITER',
   'All':'Alle',
   'Confirm Password': 'Passwort bestätigen',
   'Reset your Password':'Passwort zurücksetzen',
   'Group id':'Gruppen ID',
   'Check all': 'Alle auswählen',
   'Uncheck all' : 'Auswahl aufheben',
   'Not subscribed': 'Nicht eingeschrieben',
   'Reset': 'löschen',
   'dashboardstats': 'zeige {users} {userstat} und  {courses} {coursesstat} ',
   'Reminder': 'Erinnerungen',
   'Reminder email': 'Erinnerungs email',
   'Email timespan': 'E-Mail Zeitspanne',  
   "Email timespan is required" : "E-Mail Zeitspanne ist notwendig",
   'Reminder created successfully' : 'Erinnerung erfolgreich erstellt',
   'Reminder updated successfully' : 'Erinnerung erfolgreich aktualisiert',
   'Inventory number': 'Inventar Nummer',
   'Setup Items': 'Einrichtung',
   'Items Board':'Fälligkeiten',
   'Task Center':'Aufgaben Center',
   'Task Template': 'Aufgabenvorlagen',
   'Tasks':'Aufgaben',
   'Task Group':'Aufgabengruppe',
   'User Group':'Nutzergruppe',
   'All Groups': 'Alle Gruppen',
   'Personal Template': 'Eigene Vorlage',

   'Template name': 'Vorlagenname',
   'Validity':'Zeitraum',
   'Select template': 'Vorlage auswählen',
   'Template name is required':'Vorlagenname is notwendig',
   'Validity is required':'Zeitraum wird benötigt',
   'Template file is required':'Vorlagendatei wird benötigt',

   'Operational status':'operationaler Status',
   'Operational status is required':'operationaler Status wird benötigt',
   'Not operational': 'nicht einsatzfähig',
   'Operational':'einsatzfähig',   
   'Serial number': 'Seriennummer',
   'Category': 'Kategorie',
   'Add category': 'Kategorie hinzufügen',  

   'Update document': 'Board',
   'Create document': 'Einrichtung',
   'Task template id': 'Aufgabenvorlagen ID',
   'Add Task Center template': 'Aufgabenvorlage hinzufügen',
   'Edit Task template':'Aufgabenvorlage ändern',
   'Task template name': 'Aufgabenvorlagename',
   'Task templates' : 'Aufgabenvorlagen',
   'Task id': 'Aufgaben ID',
   'Validity type is required': 'Verhalten wird benötigt',
   'Validity type': 'Verhalten',
   'Add Task template':'Aufgabenvorlage hinzufügen',
   'One time': 'Einmalig',
   'Recurring': 'Wiederholend',
   'Task template added successfully': 'Aufgabenvorlage erfolgreich hinzugefügt',
   'Task template updated successfully': 'Aufgabenvorlage erfolgreich geändert',
   'Add Task': 'Aufgabe hinzufügen',
   'Edit Task': 'Aufgabe editieren',
   'Task name':'Aufgabenname',  
   'Task template':'Aufgabenvorlage',
   'Edit Task document': 'Aufgaben Dokument ändern',
   'Update Task document':'Aufgaben Dokument aktualisieren',  
   'Task template are required': 'Aufgabenvorlage wird benötigt',
   'Task description is required': 'Aufgabenbeschreibung wird benötigt',
   'Task document updated successfully': 'Aufgabendokument erfolgreich geändert',
   'Task added successfully' : 'Aufgabe erfolgreich hinzugefügt',
   'Task updated successfully' : 'Aufgabe erfolgreich geändert',
   'Task name is required':'Aufgabenname wird benötigt',
   'Task group id': 'Aufgabengruppen ID',
   'Add Task Group': 'Aufgabengruppe hinzufügen',
   'Edit Task Group': 'Aufgabengruppe ändern',
   'Task group name': 'Aufgabengruppenname',
   'Task group name is required': 'Aufgabengruppenname wird benötigt',
   'Task group added successfully' : 'Aufgabengruppenname erfolgreich hinzugefügt',
   'Task group updated successfully' : 'Aufgabengruppen erfolgreich geändert',
   'Add Personal document':'Persönliches Dokument hinzufügen',
   'Edit Personal document': 'Persönliches Dokument ändern',
   'Personal template name' : 'Name der persönliche Vorlage',
   'Personal templates': 'persönliche Vorlagen',
   'Personal template name is required': 'persönliche Vorlage wird benötigt',
   'Personal template added successfully': 'persönliche Vorlage erfolgreich hinzugefügt',
   'Personal template updated successfully':'persönliche Vorlage erfolgreich geändert',
   'Task group':'Aufgabengruppe',   
   'Serial number is required':'Seriennummer wird benötigt',
   'Video': 'Video',
   'Remove out from Inbox':'Aus der Inbox entfernen',
   'Update Calibration document': 'Dokument erneuern',
   'Certifications': 'Zertifikate',
   'Course name':'Kurs',
   'Completed on':'bestanden am',
   'Report': 'Meldung',
   'Report Issue': 'Fehler melden',
   'Slide id is required': 'Slide ID wird benötigt',
   'Slide Id': 'Slide ID',
   'Message is required': 'Nachricht darf nicht leer sein',
   'Message': 'Nachricht',
   'Bug sent successfully': 'Meldung erfolgreich übermittelt',
   'Drafts': 'Entwürfe',
   'Title is required' : 'Titel wird benötigt',
   'Title must be less than 20 characters' : 'Der Titel muss weniger als 20 Zeichen betragen',
   'Title must be less than 4 characters': 'Title must be less than 4 characters',
   'Is External Group':'Ist eine externe Gruppe',
   'External Users':'Externe Benutzer',
   'Add equipment template' : 'Ausrüstungsvorlage hinzufügen',
   'Edit equipment template': 'Ausrüstungsvorlage bearbeiten',

   'Font is required':'Schriftart wird benötigt',
   'Font size is required':'Schriftgröße wird benötigt',
   'Certificate is required':'Vorlagedatei wird benötigt',
   'Please drop fields on PDF':'Bitte setzten See die Felder auf die PDF',
   'Please select font size':'Bitte wählen Sie eine Schriftgröße',
   'Please select font':'Bitte wählen Sie eine Schriftart',
   'Preview':'Vorschau',
   "Font":'Schrift',
   "Font size":'Schriftgröße',
   'Add personal template': 'Vorlage hinzufügen',
   'Edit personal template': 'Vorlage bearbeiten',
   'Add task center template':'Task Center Vorlage hinzufügen',
   'Edit task center template':'Task Center Vorlage ändern',
   'Label is required': 'Label wird benötigt',
   'Label types': 'Typ',
   'Label type is required': 'Typ wird benötigt ',
   'Add custom label': 'Feld hinzufügen ',
   'Add document': 'Dokument hinzufügen ',
   'Add template': 'Vorlage hinzufügen ',
   'Edit template': 'Vorlage ändern',
   'Template is required': 'Vorlage wird benötigt ',
   'Label': 'Feld',
   'Add label': 'Feld hinzufügen ',
   'File form': 'Dokument hochladen',
   'Custom form': 'Formular ausfüllen',
   'Please fill custom form or file form completely': 'Bitte laden Sie ein Dokument hoch oder füllen Sie das Formular mit ihren Ergebnissen',
   'Field is required': 'Feld wird benötigt',
   'File is required': 'Dokument wird benötigt',
   'View Template': 'Vorlage ansehen',
   'Is External User':'Ist externer Benutzer',
   'Vouchers': 'Gutscheine',
   'Order': 'Bestellung',
   'Voucher Purchased Successfully': 'Gutschein erfolgreich bestellt',
   'Coupons': 'Codes',
   'View Coupons': 'Codes ansehen',
   'Send Coupons': 'Codes verschicken',
   'Sent To': 'senden',
   'Redeemed': 'eingelöst',
   'Revoke': 'zurückziehen',
   'Vouchers Available to Send': 'verfügbare Gutscheine',
   'UsersAdd': 'Nutzerauswahl',
   'Emails': 'Emailauswahl',
   'GroupsAdd': 'Gruppenauswahl',
   
   'Buy Vouchers' : 'Gutscheine kaufen',
   'Manage Vouchers' : 'Gutscheine verwalten',
   'User Groups' : 'Nutzergruppen',
   'Email Ids' : 'Email',
   
   'unused' : 'noch nicht eingelöst',
   'used' : 'eingelöst',
   'revoked': 'zurückgezogen',
   'Are you sure want to Revoke the Coupon?' : 'Sind Sie sicher, dass Sie den Gutschein zurückziehen wollen ?',
   
   'Order Purchase Confirmation' : 'Bestellbestätigung',
   'Order Summary' : 'Bestellung',
   'Subtotal' : 'Summe',
   'Coupon Code' : 'Gutscheincode',
   'Total' : 'Summe',
   'Apply' : 'anwenden',
   'I agree' : 'I habe die Nutzungsbedingungen gelesen und akzeptiere diese',
   'terms' : '[Nutzungsbedingungen]',
   'Pay securely using' : 'Sicher zahlen mit',
   'Send To':  'Senden an',
   'Need to change payment method?':  'Zahlungsmethoden ändern',
   'Thank you for Subscribing' : 'Vielen Dank für den Kauf',
   'You can find subscribed courses in your Dashboard' : 'Sie finden Ihre Kurse auf dem Dashboard',
   'Go to Dashboard':  'zum Dashboard',
   'Coupon Code Sent Successfully!': 'Gutschein erfolgreich gesendet!',
   'Some Problem occurred!': 'Es ist ein Fehler aufgetreten.',
   'Invalid Coupon Code':'Ungültiger Coupon',
   'Coupon applied Successfully':'Coupon ERFOLGREICH angewendet',
   'Limit reached':'Limit erreicht',
   'Number of Vouchers': 'Anzahl Gutscheine',
   'Buy Course Vouchers': 'Kurs-Gutscheine kaufen',
   'Manage Course Vouchers': 'Kurs-Gutscheine verwalten',
   'Buy Tutor Vouchers': 'Tutor-Gutscheine kaufen',
   'Manage Tutor Vouchers': 'Tutor-Gutscheine verwalten',
   'Book a Tutor': 'Tutor buchen',
   'No Tutor Products to display': 'Keine Tutor-Produkte verfügbar',
   'Tutor Products Available': 'Tutor-Produkte verfügbar',
   'Book': 'Buchen',
   'Pick another': 'Etwas anderes auswählen',
   'Booking Complete': 'Buchung erfolgreich',
   'Please check you email for further details.': 'Bitte überprüfen Sie ihre E-Mail Inbox für weitere Details',
   'Book Again' : 'Noch einmal buchen',
   'No User Groups assigned to this Course': 'Diesem Kurs sind keine Benutzergruppen zugewiesen',
   'Login with Office' : 'Melden Sie sich mit Office an',
   'Oops there was an error.' : 'Hoppla, es ist ein Fehler aufgetreten.',
   'Please contact Administrator.' : 'Bitte wenden Sie sich an den Administrator.',
   'Redirecting...' : 'Umleitung...',
   'Complete Your Personal Info' : 'Vervollständigen Sie Ihre persönlichen Daten',
   'Please provide your personal information. All Details are mandatory and will appear in your certificate as shown below.':'Bitte geben Sie Ihre persönlichen Daten an. Alle Details sind obligatorisch und erscheinen in Ihrem Zertifikat wie unten gezeigt.',
   'Personal Info' : 'Persönliche Informationen',

   'Question': 'Frage',
   'Questions': 'Fragen',
   'Add Question' : 'Frage hinzufügen',
   'Edit Question' : 'Frage bearbeiten',
   'Question id' : 'Fragen-ID',
   'Question name is required' : 'Name der Frage ist erforderlich',
   'Question text is required' : 'Fragetext ist erforderlich',
   'Question help text is required': 'Hilfetext für die Frage ist erforderlich',
   'At least one Question Topic is required': 'Mindestens ein Fragethema ist erforderlich',
   'Question Type is required': 'Fragetyp ist erforderlich',
   'Language is required': 'Sprache ist erforderlich',
   'The Topic ' : 'Das Thema',
   ' is already added. Please select from the list or add a new topic.' : 'ist bereits hinzugefügt. Bitte wählen Sie aus der Liste oder fügen Sie ein neues Thema hinzu.',
   'Answers' : 'Antworten',
   'Answer' : 'Antworten',
   'Question name' : 'Name der Frage',
   'Question text' : 'Fragetext',
   'Question Help Text' : 'Frage Hilfetext',
   'Question Type' : 'Fragetyp',
   'Question Topic' : 'Frage Thema',
   'Add Topic' : 'Thema hinzufügen',
   'Points' : 'Punkte',
   'Answer is required' : 'Antwort ist erforderlich',
   'Single-select' : 'Einfachauswahl',
   'Multi-select' : 'Mehrfachauswahl',
   'single-select' : 'Einfachauswahl',
   'multiple-select' : 'Mehrfachauswahl',

   /****************** Quiz *************/

   'Quiz id' : 'Quiz-ID',
   'Add Quiz' : 'Quiz hinzufügen',
   'Edit Quiz' : 'Quiz bearbeiten',
   'Quiz name' : 'Quiz Name',
   'Quiz Description' : 'Quiz Beschreibung',
   'Select Questions' : 'Wählen Sie Fragen aus',
   'Passing Percent(%)' : 'Bestehen Prozent(%)',
   'The value must be a positive number and less than or equal to ' : 'Der Wert muss eine positive Zahl und kleiner oder gleich sein ',
   'The value must be less than or equal to ' : 'Der Wert muss kleiner oder gleich sein ',
   'Is Randomised' : 'Ist Randomisiert',
   'Question Count' : 'Anzahl der Fragen',
   'Questions Selected' : 'Fragen ausgewählt',
   'Is Mandatory' : 'Ist Obligatorisch',
   'Topic' : 'Thema',
   'Order Index' : 'Reihenfolge',
   'Quiz image' : 'Quizbild',
   'Quiz Language' : 'Quiz Sprache',
   'Quiz Type' : 'Quiz Typ',
   'Quiz name is required' : 'QuizName ist erforderlich',
   'Quiz Type is required' : 'Quiztyp ist erforderlich',
   'Passing Percent is required' : 'Das Bestehen von Prozent ist erforderlich',
   'The value must be a positive number' : 'Der Wert muss eine positive Zahl sein',
   'Has Randomized Subset' : 'Hat eine randomisierte Teilmenge',
   'Randomized Question Count' : "Anzahl der randomisierten Fragen",
   'Quiz contains a total of ' : 'Quiz enthält insgesamt ',
   ' Question. Out of which ' : ' Frage. ',
   ' Questions. Out of which ' : ' Fragen. ',
   ' Question will be shown, ' : ' Frage wird angezeigt, ',
   ' Questions will be shown, ' : ' Fragen werden angezeigt, ',
   ' is a Mandatory Question and ' : ' ist eine Pflichtfrage und ',
   ' are Mandatory Questions and ' : ' sind Pflichtfragen und ',
   ' no ' : ' nein ',
   ' Question is randomized. ' : ' Frage ist randomisiert. ',
   ' Questions are randomized. ' : ' Fragen werden randomisiert. ',
   'YES' : 'JA',
   'NO' : 'NEIN',
   'Course is required' : 'Kurs erforderlich',
   'Select at least one module' : 'Wählen Sie mindestens ein Modul aus',

   'Take Quiz' : 'Quiz starten',
   'Instructions' : 'Anweisungen',
   'No Quiz to display for this course' : 'Für diesen Kurs existiert kein Quiz',
   'Quiz Instruction 1' : 'Alle Antworten sind obligatorisch, um die maximale Punktzahl zu erreichen.',
   'Quiz Instruction 2' : 'Sie müssen alle Fragen beantworten, um das Quiz absenden zu können',
   'Quiz Instruction 3' : 'Dieses Quiz dient nur zu Übungszwecken',
   'Quiz Instruction 4' : 'Üben Sie so oft wie möglich. Das Quiz-Endergebnis hat keinen Einfluss auf den Zertifizierungsprozess, sondern hilft Ihnen nur, sich gut auf die Zertifizierungsprüfung vorzubereiten.',
   'Quiz Instruction 5' : 'Benötigter Prozentsatz um zu bestehen ',
   'Start' : 'Anfang',
   'Quit' : 'Aufhören',
   'Result' : 'Ergebnis',
   'Results' : 'Ergebnisse',
   'You scored' : 'Dein Ergebnis',
   'Percent of passing is' : 'Prozent um zu Bestehen:',
   'Take Quiz Again': 'Machen Sie das Quiz erneut',
   'You have already taken the daily quiz' : 'Sie haben bereits am täglichen Quiz teilgenommen',

   'Daily Quiz Instruction 1' : 'Alle Antworten sind obligatorisch, um die maximale Punktzahl zu erreichen.',
   'Daily Quiz Instruction 2' : 'Sie müssen alle Fragen beantworten, um das Quiz einreichen zu können.',
   'Daily Quiz Instruction 3' : 'Sie können dieses Quiz nur einmal am Tag machen. Das Quiz-Endergebnis hat keinen Einfluss auf den Zertifizierungsprozess, sondern hilft Ihnen nur, sich gut auf die Zertifizierungsprüfung vorzubereiten.',
   'Daily Quiz Instruction 4' : 'Die maximale Anzahl an Fragen für dieses Quiz ist ',
   'Daily Quiz Instruction 5' : 'Prozentsatz des Bestehens ist ',

   'Quizzes': 'Quiz',
   'Daily Quiz' : 'Tägliches Quiz',
   'All Quizzes' : 'Alle Quiz',
   'Take Daily Quiz' : 'Nehmen Sie am täglichen Quiz teil',
   'No Questions Found for Daily Quiz' : 'Keine Fragen für tägliches Quiz gefunden',
   'Have you subscribed to Courses?' : 'Haben Sie Kurse abonniert?',
   'Have you completed any modules in a course? Does that module have any quiz?' : 'Haben Sie Module in einem Studiengang absolviert? Hat dieses Modul ein Quiz?',
   'Have you completed any Courses? Does that Course have any quiz?' : 'Haben Sie Kurse absolviert? Hat dieser Kurs ein Quiz?',
   'Has your company configured settings for Daily Quizzes?' : 'Hat Ihr Unternehmen Einstellungen für tägliche Quizze konfiguriert?',
   'No Quizzes to show' : 'Keine Quizze zum Anzeigen',

   "Quiz Completed" : "Quiz abgeschlossen",
   "Course Completed" : "Kurs abgeschlossen",
   "Module Completed" : "Modul abgeschlossen",
   "Role Assigned" : "Rolle zugewiesen",
   "Role Received" : "Rolle erhalten",
   "Sets user status to disabled" : "Setzt den Benutzerstatus auf deaktiviert",
   "Status is set to be disabled" : "Der Status ist auf deaktiviert gesetzt",
   "Left Group" : "Linke Gruppe",
   "Joined Group" : "Gruppe beigetreten",
   "New" : "Neu",
   "Internal" : "Intern",
   "Quiz Passed" : "Quiz bestanden",

   "group": {
      "left": {
         "name": "Linke Gruppe",
         "logType": {
            "key": "Protokolltyp",
            "description": "Dies beschreibt den Typ des Geschehnisses.",
         },
         "groupName": {
            "key": "Gruppenname",
            "description": "Die beschreibt den Gruppennamen.",
         },
         "groupType": {
            "key": "Gruppentyp",
            "description": "Dies beschreibt ob es sich um eine interne oder externe Gruppe handelt.",
         },
      },
      "joined": {
         "name": "Gruppe beigetreten",
         "logType": {
            "key": "Protokolltyp",
            "description": "Dies beschreibt den Typ des Geschehnisses.",
         },
         "groupName": {
            "key": "Gruppenname",
            "description": "Die beschreibt den Gruppennamen.",
         },
         "groupType": {
            "key": "Gruppentyp",
            "description": "Dies beschreibt ob es sich um eine interne oder externe Gruppe handelt.",
         },
      },
   },
   "course": {
      "completed": {
         "status": {
            "key": "Status",
            "description": "Dies beschreibt den Kursstatus",
         },
         "logType": {
            "key": "Protokolltyp",
            "description": "Dies beschreibt den Typ des Geschehnisses.",
         },
         "courseName": {
            "key": "Kursname",
            "description": "Dies beschreibt den Namen des Kurses.",
         },
         "relatedModules": {
            "key": "Verwandte Module",
            "description": "Dies beschreibt die Module, welche in diesem Kurs unterrichtet werden.",
         },
         "courseDescription": {
            "key": "Kursbeschreibung",
            "description": "Die Kursbeschreibung.",
         },
      },
   },
   "module": {
      "completed": {
         "score": {
            "key": "Punktzahl",
            "description": "Dies beschreibt den modulspezifischen Punktestand.",
         },
         "status": {
            "key": "Status",
            "description": "Dies beschreibt den Modulstatus.",
         },
         "logType": {
            "key": "Protokolltyp",
            "description": "Dies beschreibt den Typ des Geschehnisses.",
         },
         "relatedCourses":{
            "key": "Verbundene Kurse",
            "description": "Dies sind die Kurse, mit denen das Modul verknüpft ist.",
         },
         "timeSpent": {
            "key": "Zeitaufwand",
            "description": "Dies beschreibt die Zeit, die ein benutzer im Modul verbracht hat.",
         },
         "moduleName": {
            "key": "Modulname",
            "description": "Der Name des Moduls.",
         },
         "relatedCourse": {
            "key": "Verwandter Kursname",
            "description": "Dies beschreibt den Kurs aus dem das Modul stammt.",
         },
         "totalAttempts": {
            "key": "Gesamtversuche",
            "description": "Dies beschreibt die Anzahl von Versuchen, die ein benutzer gebraucht hat um das Modul abzuschließen.",
         },
         "moduleDescription": {
            "key": "Modulbeschreibung",
            "description": "Die Modulbeschreibung.",
         },
         "moduleVersionNo": {
            "key": "Modul-Versionsnr",
            "description": "Dies beschreibt die Modulversionsnummer.",
         },
         "scoreInPercentage": {
            "key": "Punktzahl in Prozent",
            "description": "Dies beschreibt den Punktestand in % von 100.",
         },
         "moduleVersionType": {
            "key": "Modulversionstyp",
            "description": "Dies beschreibt den Typ der Modulversion.",
         },
      },
   },
   "quiz": {
      "completed": {
         "quizName": {
            "key": "Quizname",
            "description": "Dies ist der Name des Quiz.",
         },
         "quizDescription": {
            "key": "Quiz-Beschreibung",
            "description": "Dies ist eine Beschreibung des Quiz.",
         },
         "quizType": {
            "key": "Quiz-Typ",
            "description": "Dies beschreibt den Typ des Quiz.",
         },
         "links": {
            "key": "Verknüpfungen",
            "description": "Dies beschreibt die verknüpften Quizzes.",
         },
         "score": {
            "key": "Punktzahl",
            "description": "Dies beschreibt die erreicht Punkteanzahl im Quiz.",
         },
         "status": {
            "key": "Status",
            "description": "Dies beschreibt den Status des Quiz.",
         },
         "logType": {
            "key": "Protokolltyp",
            "description": "Dies beschreibt den Typ des Geschehnisses.",
         },
         "scoreInPercentage": {
            "key": "Punktzahl in Prozent",
            "description": "Dies beschreibt die erreicht Punkteanzahl im Quiz in Prozent",
         },
      },
      "passed" :{
         "https://learninglocker&46;net/result-duration": {
            "seconds": {
               "key": "Zeitdauer",
               "description": "Dies ist die Zeit, die zum Beenden des Quiz benötigt wurde.",
            },
         },
         "quiz_id": {
            "key": "Quiz-ID",
            "description": "Dies ist die Quiz-ID.",
         },
         "sendStatement": {
            "key": "Erklärung senden",
            "description": "Dadurch wird die Anweisung gesendet",
         },
         "logType": {
            "key": "Protokolltyp",
            "description": "Dies beschreibt den Typ des Geschehnisses.",
         },
      },
   },
   "permission": {
      "assigned": {
         "logType": {
            "key": "Protokolltyp",
            "description": "Dies beschreibt den Typ des Geschehnisses.",
         },
         "recipient": {
            "key": "Empfänger",
            "description": "Dies beschreibt den Empfänger der Rolle/Freigabe.",
         },
         "customRoles": {
            "key": "Benutzerdefinierte Rollen",
            "description": "Dies beschreibt die benutzerdefinierten Rollen/Freigaben.",
         },
         "permissions": {
            "key": "Berechtigungen",
            "description": "Dies beschreibt die verknüpften Freigaben.",
         },
      },
      "received": {
         "logType": {
            "key": "Protokolltyp",
            "description": "Dies beschreibt den Typ des Geschehnisses.",
         },
         "assignedBy": {
            "key": "Zugeteilt von",
            "description": "Dies beschreibt die vergebene Person für die Rollen/Freigaben.",
         },
         "customRoles": {
            "key": "Benutzerdefinierte Rollen",
            "description": "Dies beschreibt die benutzerdefinierten Rollen/Freigaben.",
         },
         "permissions": {
            "key": "Berechtigungen",
            "description": "Dies beschreibt die verknüpften Freigaben.",
         },
      },
   },
   "status": {
      "disabled": {
         "logType": {
            "key": "Protokolltyp",
            "description": "Dies beschreibt die Art des Ereignisses.",
         },
         "disabledBy": {
            "key": "Deaktiviert durch",
            "description": "Dies ist der Benutzer, der die Deaktivierungsaktion durchgeführt hat.",
         },
         "disabledUser": {
            "key": "Deaktivierter Benutzer",
            "description": "Dies ist der Benutzer, der deaktiviert werden soll.",
         },
         "disableFromDate": {
            "key": "Deaktiviert ab Datum",
            "description": "Dies ist das Datum, an dem der Benutzer deaktiviert wird.",
         },
      },
   },

   'You need to complete previous modules' : 'Bitte absolviere zuerst die vorhergehenden Module',
   'User Documents': 'Dokumente',
   'User Activity': 'Aktivität',
   'Filter By': 'Filtern nach',
   'Inverse Timeline': 'Zeitachse umdrehen',
   'View Details': 'Details',
   'Key': 'Aktivität',
   'Value': 'Wert',
   'No Activity to Show': 'Keine Aktivität zum Anzeigen',

   "Custom Email Template": "Benutzerdefinierte E-Mail-Vorlage",
   "Use these placeholders while constructing Email" : "Diese Platzhalter beim Erstellen von E-Mails verwenden",
   "Email template" : "E-Mail-Vorlage",
   "Send Test Mail" : "Testmail senden",
   "Copied to Clipboard" : "In die Zwischenablage kopiert",

   "System Emails" : "System-E-Mails",
   "Scheduled Mails" : "Geplante Mails",
   "Trigger Mails" : "Trigger-Mails",
   "Reminder Mails" : "Erinnerungsmails",

   "System Email Template" : "System-E-Mail-Vorlage",
   "Email Template id" : "E-Mail-Vorlagen-ID",
   "Template Name": "Vorlagenname",
   "Select Frequency" : "Wählen Sie Frequenz",
   "Frequency": "Frequenz",
   "Start Date" : "Startdatum",
   "Start Time" : "Startzeit",
   "Scheduled Email Notifications" : "Geplante E-Mail-Benachrichtigungen",
   "Select Recipient Type" : "Empfängertyp auswählen",
   "Scheduler Settings" : "Scheduler-Einstellungen",
   "Time" : "Zeit",
   "Cycles": "Zyklen",
   "Total Cycles": "Totla-Zyklen",
   "From Cycle" : "Vom Zyklus",
   "To Cycle" : "Zu Zyklus",
   "Campaign? Yes": "Kampagne? Ja",
   "Campaign? No": "Kampagne? Nein",
   "Placeholders" : "Platzhalter",
   "You can choose these placeholders while constructing Email" : "Sie können diese Platzhalter beim Erstellen von E-Mails auswählen",
   "Copied to Clipboard!" : "In die Zwischenablage kopiert!",
   "Subject in" : "Betreff in",
   "Custom Email Subject" : "Betreff",
   "Send" : "Senden",
   "Enter Mail" : "Mail eingeben",
   "Recipient is required" : "Empfänger ist erforderlich",
   "Frequency is required" : "Frequenz ist erforderlich",
   "Mail Cycle Count is Over. Increase Cycle Count if you want to keep sending mails" : "Mail Zyklus Anzahl is Over. Erhöhen Sie Zyklus Anzahl, wenn Sie weiterhin E-Mails senden möchten",
   "Mail Sent! Please check email" : "E-Mail gesendet! Bitte E-Mail überprüfen",
   "You need to fill the at least one language, Email Subject and Email Body" : "Sie müssen mindestens eine Sprache, einen E-Mail-Betreff und einen E-Mail-Text ausfüllen",
   "Notification Template created successfully" : "Benachrichtigungsvorlage erfolgreich erstellt",
   "Email Notification successfully Updated" : "E-Mail-Benachrichtigung erfolgreich aktualisiert",
   "Add Cycle Count, If you want Endless Cycle set value to 0." : "Zyklus Anzahl hinzufügen, wenn Sie endloser Zyklus wollen, setzen Sie den Wert auf 0.",
   "Subject in German" : "Betreff auf Deutsch",
   "Subject in English" : "Betreff auf Englisch",
   "Email in German" : "E-Mail auf Deutsch",
   "Email in English" : "E-Mail auf Englisch",
   "Add Template" : "Vorlage hinzufügen",
   "Select Mail Template" : "Wählen Sie E-Mail-Vorlage aus",
   "Company Language is required" : "Unternehmenssprache ist erforderlich",
   "Daily" : "Täglich",
   "Weekly" : "Wöchentlich",
   "Monthly" : "Monatlich",
   "Yearly" : "Jährlich",
   "daily" : "Täglich",
   "weekly" : "Wöchentlich",
   "monthly" : "Monatlich",
   "yearly" : "Jährlich",

   "Triggered Mail Templates" : "Ausgelöste E-Mail-Vorlagen",
   "Trigger Event" : "Trigger-Ereignis",
   "Due Days": "Fälligkeitstage",
   "Trigger Time" : "Triggerzeit",
   "Triggered Email Template" : "Ausgelöste E-Mail-Vorlage",
   "Trigger Email Event Settings" : "Einstellungen für E-Mail-Ereignisse auslösen",
   "Add Due Days Count, Email will be sent Due days Before Due Date." : "Zählung der Fälligkeitstage hinzufügen, E-Mail wird Fälligkeitstage vor dem Fälligkeitsdatum gesendet.",
   "Timezone": "Zeitzone",
   "No placeholders available" : "Keine Platzhalter verfügbar",
   "Inbox Documents" : "Dokumente im Posteingang",
   "Course Subscriptions Ending" : "Kursabonnements enden",
   "Send After" : "Nachher senden",

   "Reminder Event" : "Erinnerungsereignis",
   "Reminder After Every" : "Erinnerung nach jedem",
   "Reminder name" : "Erinnerungsname",
   "Reminder Settings" : "Erinnerungseinstellungen",
   "Remind After Every" : "Nach jedem erinnern",
   "Days" : "Tage",
   "Signup" : "Anmeldung",
   "signup" : "Anmeldung",
   "Initialize Inbox Documents" : "Posteingangsdokumente initialisieren",
   "initialize_inbox_document" : "Posteingangsdokumente initialisieren",
   "Please Enter the number of days you want to send the Reminder" : "Bitte geben Sie die Anzahl der Tage ein, an denen Sie die Erinnerung senden möchten",

   'Course Statistics' : 'Kursstatistik',
   'Per Course' : 'Pro Kurs',
   'Per User' : 'Pro Benutzer',
   'Active Subscribers' : 'Aktive Abonnenten',
   'Course Modules' : 'Kursmodule',
   'Learning Progress of Users' : 'Lernfortschritt der Benutzer',
   'Passed Percentage of Currently Subscribed Users' : 'Bestandener Prozentsatz der derzeit abonnierten Benutzer',
   'Pass activity over time' : 'Kursfortschritt im Laufe der Zeit',
   'Number of Users' : 'Anzahl der Benutzer',
   'Percentage Of Course Completed' : 'Prozentsatz der abgeschlossenen Kurse',
   'Average Time Spent' : 'Durchschnittliche verbrachte Zeit',
   'No Time Spent' : 'Kein Zeitaufwand',
   'Average Number Of Attempts to Complete' : 'Durchschnittliche Anzahl der Abschlussversuche',
   'Not Attempted' : 'Nicht versucht',
   'Subscribed Users Learning Status' : 'Lernstatus der abonnierten Benutzer',
   'Number of active subscribers' : 'Anzahl aktiver Abonnenten',
   'Total Number of Modules' : 'Gesamtzahl der Module',
   'Number of users subscribed since first publishing' : 'Anzahl der abonnierten Benutzer seit der ersten Veröffentlichung',
   'Not Passed' : 'Nicht bestanden',
   'Started' : 'Gestartet',
   'Not Started' : 'Nicht angefangen',
   'Finished' : 'Fertig',
   'Pass Activity of Users in Weeks' : 'Aktivität der Benutzer in Wochen',
   'Weeks To Pass' : 'Wochen zu bestehen',

   'User Statistics' : 'statistik',
   'Courses Subscribed' : 'Abonnierte Kurse',
   'Number of Courses Subscribed' : 'Anzahl der abonnierten Kurse',
   'Active Courses' : 'Aktive Kurse',
   'Number of Active Courses' : 'Anzahl aktiver Kurse',
   'Course Progress' : 'Kursfortschritt',
   'Pass Percentage of currently Subscribed Courses' : 'Bestanden Prozentsatz der derzeit abonnierten Kurse',
   'Status of learning progress' : 'Status des Lernfortschritts',
   'Number of Courses' : 'Anzahl Kurse',
   'Learning Progress in Percentage' : 'Lernfortschritt in Prozent',
   'All Users loaded' : 'Alle Benutzer geladen',
   'Module Progress' : 'Modulfortschritt',
   'Module Attempts' : 'Modulversuche',
   'No Attempts' : 'Keine Versuche',

   'Group Statistics' : 'Gruppenstatistik',
   'Documents' : 'Unterlagen',
   'Equipment Items' : 'Ausrüstungsgegenstände',
   'Number of users in Group' : 'Anzahl der Benutzer in der Gruppe',
   'Number of documents managed through Group' : 'Anzahl der über die Gruppe verwalteten Dokumente',
   'Number of tasks managed through Group' : 'Anzahl der Aufgaben, die über die Gruppe verwaltet werden',
   'Number of equipment managed through Group' : 'Anzahl der Geräte, die von der Gruppe verwaltet werden',
   'Group Admin' : 'Gruppenadministrator',
   'Details of Group Admin' : 'Details des Gruppenadministrators',
   'Breached Documents' : 'Überfällige Dokumente',
   'Number and details of breached Documents' : 'Anzahl und Details der überfälligen Dokumente',
   'Current Status of Inbox Process Progress' : 'Aktueller Status des Posteingangs-Prozessfortschritts',
   'Well maintained' : 'Gut gepflegt ',
   'Yet to setup' : 'Einrichtung offen',
   'stage_1' : 'Knapp vor Verletzung',
   'stage_2' : 'Dringend',
   'days overdue' : 'Tage überfällig',
   'Jump to Inbox' : 'Zum Posteingang springen',

   '2-Step Verification' : '2-Faktor-Authentifizierung',
   'Enter the 6 digit code that we sent to your email address to finish setting up two-factor authentication.' : 'Geben Sie den 6-stelligen Code ein, den wir an Ihre E-Mail-Adresse gesendet haben, um die Einrichtung der Zwei-Faktor-Authentifizierung abzuschließen.',
   'Token' : 'Zeichen',
   'Back' : 'Zurück',
   'Token is required' : 'Token ist erforderlich',
   'Invalid two factor auth code' : 'Ungültiger Zwei-Faktor-Authentifizierungscod',

   'question-key' : 'Frage',
   'quiz-key' : 'Quiz',
   'custom-role-key' : 'Benutzerdefinierte Rolle',
   'user-key' : 'Benutzer',
   'custom-email-scheduling-key' : 'Benutzerdefinierte E-Mail-Planung',
   'group-key' : 'Gruppe',
   'personal-template-key' : 'Persönliche Vorlage',
   'additional-pages-key' : 'Zusätzliche Seiten',
   'equipment-template-key' : 'Ausrüstungsvorlage',
   'equipment-group-key' : 'Ausrüstungsgruppe',
   'equipment-key' : 'Ausrüstung',
   'test-case-template-key' : 'Testfallvorlage',
   'test-case-group-key' : 'Testfallgruppe',
   'test-case-key' : 'Testfall',
   'statistics-key' : 'Statistiken',
   'inbox-key' : 'Posteingang',

   'can-create-question-key' : 'kann-Fragen-erstellen',
   'can-update-question-key' : 'kann-Fragen-editieren',
   'can-delete-question-key' : 'kann-Fragen-löschen',
   'can-create-quiz-key' : 'kann-Quiz-erstellen',
   'can-update-quiz-key' : 'kann-Quiz-editieren',
   'can-delete-quiz-key' : 'kann-Quiz-löschen',
   'can-create-custom-role-key' : 'kann-Rollen-erstellen',
   'can-update-custom-role-key' : 'kann-Rollen-editieren',
   'can-delete-custom-role-key' : 'kann-Rollen-löschen',
   'can-assign-custom-role-key' : 'kann-Rollen-zuweisen',
   'can-audit-user-history-key' : 'kann-den-Benutzerverlauf-prüfen',
   'has-access-to-all-mail-types-key' : 'hat-Zugriff-auf-alle-E-Mail-Typen',
   'has-access-to-system-mails-key' : 'hat-Zugriff-auf-System-E-Mails',
   'has-access-to-scheduled-mails-key' : 'hat-Zugriff-auf-geplante-E-Mails',
   'has-access-to-trigger-mails-key' : 'hat-Zugriff-auf-automatisierte-E-Mails',
   'has-access-to-reminder-mails-key' : 'hat-Zugriff-auf-Erinnerungs-Mails',
   'can-create-group-key' : 'kann-Nutzergruppen-erstellen',
   'can-update-group-key' : 'kann-Nutzergruppen-aktualisieren',
   'can-delete-group-key' : 'kann-Nutzergruppen-löschen',
   'can-create-personal-template-key' : 'kann-eine-persönliche-Vorlage-erstellen',
   'can-update-personal-template-key' : 'kann-persönliche-Vorlage-aktualisieren',
   'can-delete-personal-template-key' : 'kann-eine-persönliche-Vorlage-löschen',
   'has-access-to-additional-pages-key' : 'kann-eine-persönliche-Vorlage-löschen',
   'has-access-to-additional-pages-resource-key' : 'kann-zusätzliche-Resourcen-einsehen',
   'can-create-equipment-template-key' : 'kann-Equipment-Vorlagen-erstellen',
   'can-update-equipment-template-key' : 'kann-Equipment-Vorlagen-aktualisieren',
   'can-delete-equipment-template-key' : 'kann-Equipment-Vorlagen-löschen',
   'can-create-equipment-key' : 'kann-Equipment-anlegen',
   'can-update-equipment-key' : 'kann-Equipment-aktualisieren',
   'can-delete-equipment-key' : 'kann-Equipment-löschen',
   'can-create-equipment-group-key' : 'kann-Equipmentgruppen-anlegen',
   'can-update-equipment-group-key' : 'kann-Equipmentgruppen-aktualisieren',
   'can-delete-equipment-group-key' : 'kann-Equipmentgruppen-löschen',
   'can-create-test-case-template-key' : 'kann-Testcase-Vorlagen-anlegen',
   'can-update-test-case-template-key' : 'kann-Testcase-Vorlagen-aktualisieren',
   'can-delete-test-case-template-key' : 'kann-Testcase-Vorlagen-löschen',
   'can-create-test-case-group-key' : 'kann-Testcasegruppen-anlegen',
   'can-update-test-case-group-key' : 'kann-Testcasegruppen-aktualisieren',
   'can-delete-test-case-group-key' : 'kann-Testcasegruppen-löschen',
   'can-create-test-case-key' : 'kann-Testcases-anlegen',
   'can-update-test-case-key' : 'kann-Testcases-aktualisieren',
   'can-delete-test-case-key' : 'kann-Testcases-löschen',
   'has-access-to-all-statistics-key' : 'Hat-Zugriff-auf-alle-Statistiken',
   'has-access-to-pending-exercise-key' : 'hat-Zugriff-auf-ausstehende-Übung',
   'has-access-to-register-participation-key' : 'hat-Zugriff-zur-Registrierung-Beteiligung',

   'can-create-question-val' : 'Benutzer mit dieser Berechtigung dürfen neue Fragen erstellen',
   'can-update-question-val' : 'Benutzer mit dieser Berechtigung dürfen bestehende Fragen aktualisieren',
   'can-delete-question-val' : 'Benutzer mit dieser Berechtigung dürfen Fragen löschen',
   'can-create-quiz-val' : 'Benutzer mit dieser Berechtigung dürfen neue Quizzes erstellen',
   'can-update-quiz-val' :  'Benutzer mit dieser Berechtigung dürfen vorhandene Quizzes aktualisieren',
   'can-delete-quiz-val' : 'Benutzer mit dieser Berechtigung dürfen Quizzes löschen',
   'can-create-custom-role-val' : 'Benutzer mit dieser Berechtigung dürfen neue benutzerdefinierte Rollen erstellen',
   'can-update-custom-role-val' : 'Benutzer mit dieser Berechtigung dürfen vorhandene benutzerdefinierte Rollen aktualisieren',
   'can-delete-custom-role-val' : 'Benutzer mit dieser Berechtigung dürfen benutzerdefinierte Rollen löschen',
   'can-assign-custom-role-val' : 'Benutzer mit dieser Berechtigung dürfen Benutzern benutzerdefinierte Rollen zuweisen',
   'can-audit-user-history-val' : 'Benutzer mit dieser Berechtigung dürfen den Nutzungsverlauf des Benutzers anzeigen',
   'has-access-to-all-mail-types-val' : 'Benutzer mit dieser Berechtigung können alle E-Mail-Typen erstellen, ändern und löschen.',
   'has-access-to-system-mails-val' : 'Benutzer mit dieser Berechtigung können System-E-Mails erstellen, bearbeiten, anzeigen und löschen',
   'has-access-to-scheduled-mails-val' : 'Benutzer mit dieser Berechtigung können geplante E-Mails erstellen, bearbeiten, anzeigen und löschen',
   'has-access-to-trigger-mails-val' : 'Benutzer mit dieser Berechtigung können Trigger-E-Mails erstellen, bearbeiten, anzeigen und löschen',
   'has-access-to-reminder-mails-val' : 'Benutzer mit dieser Berechtigung können Erinnerungs-E-Mails erstellen, bearbeiten, anzeigen und löschen',
   'can-create-group-val' : 'Benutzer mit dieser Berechtigung dürfen Benutzergruppen erstellen',
   'can-update-group-val' : 'Benutzer mit dieser Berechtigung dürfen Benutzergruppen aktualisieren',
   'can-delete-group-val' : 'Benutzer mit dieser Berechtigung dürfen Benutzergruppen löschen',
   'can-create-personal-template-val' : 'Benutzer mit dieser Berechtigung dürfen persönliche Vorlagen erstellen',
   'can-update-personal-template-val' : 'Benutzer mit dieser Berechtigung dürfen persönliche Vorlagen aktualisieren',
   'can-delete-personal-template-val' : 'Benutzer mit dieser Berechtigung dürfen persönliche Vorlagen löschen',
   'has-access-to-additional-pages-val' : 'Benutzer mit dieser Berechtigung können zusätzliche Seiten erstellen, bearbeiten und löschen',
   'has-access-to-additional-pages-resource-val' : 'Benutzer mit dieser Berechtigung können zusätzliche Seitenressourcen erstellen und löschen',
   'can-create-equipment-template-val' : 'Benutzer mit dieser Berechtigung dürfen Gerätevorlagen erstellen',
   'can-update-equipment-template-val' : 'Benutzer mit dieser Berechtigung dürfen die Gerätevorlage aktualisieren',
   'can-delete-equipment-template-val' : 'Benutzer mit dieser Berechtigung dürfen Gerätevorlagen löschen',
   'can-create-equipment-val' : 'Benutzer mit dieser Berechtigung dürfen Geräte erstellen',
   'can-update-equipment-val' : 'Benutzer mit dieser Berechtigung dürfen Geräte aktualisieren',
   'can-delete-equipment-val' : 'Benutzer mit dieser Berechtigung dürfen Geräte löschen',
   'can-create-equipment-group-val' : 'Benutzer mit dieser Berechtigung dürfen Gerätegruppen erstellen',
   'can-update-equipment-group-val' : 'Benutzer mit dieser Berechtigung dürfen die Gerätegruppe aktualisieren',
   'can-delete-equipment-group-val' : 'Benutzer mit dieser Berechtigung dürfen Gerätegruppen löschen',
   'can-create-test-case-template-val' : 'Benutzer mit dieser Berechtigung dürfen Testfallvorlagen erstellen',
   'can-update-test-case-template-val' : 'Benutzer mit dieser Berechtigung dürfen die Testfallvorlage aktualisieren',
   'can-delete-test-case-template-val' : 'Benutzer mit dieser Berechtigung dürfen Testfallvorlagen löschen',
   'can-create-test-case-group-val' : 'Benutzer mit dieser Berechtigung dürfen Testfallgruppen erstellen',
   'can-update-test-case-group-val' : 'Benutzer mit dieser Berechtigung dürfen die Testfallgruppe aktualisieren',
   'can-delete-test-case-group-val' : 'Benutzer mit dieser Berechtigung dürfen Testfallgruppen löschen',
   'can-create-test-case-val' : 'Benutzer mit dieser Berechtigung dürfen Testfälle erstellen',
   'can-update-test-case-val' : 'Benutzer mit dieser Berechtigung dürfen Testfälle aktualisieren',
   'can-delete-test-case-val' : 'Benutzer mit dieser Berechtigung dürfen Testfälle löschen',
   'has-access-to-all-statistics-val' : 'Benutzer mit dieser Berechtigung haben Zugriff auf Kurs- und Gruppenstatistiken',
   'has-access-to-pending-exercise-val' : 'Benutzer mit dieser Berechtigung können Benutzer für eingereichte Übungen benoten',
   'has-access-to-register-participation-val' : 'Benutzer mit dieser Berechtigung können die Teilnahme von Benutzern an Veranstaltungen bestätigen',
   
   'can-create-question' : 'kann-Fragen-erstellen',
   'can-update-question' : 'kann-Fragen-editieren',
   'can-delete-question' : 'kann-Fragen-löschen',
   'can-create-quiz' : 'kann-Quiz-erstellen',
   'can-update-quiz' : 'kann-Quiz-editieren',
   'can-delete-quiz' : 'kann-Quiz-löschen',
   'can-create-custom-role' : 'kann-Rollen-erstellen',
   'can-update-custom-role' : 'kann-Rollen-editieren',
   'can-delete-custom-role' : 'kann-Rollen-löschen',
   'can-assign-custom-role' : 'kann-Rollen-zuweisen',
   'can-audit-user-history' : 'kann-den-Benutzerverlauf-prüfen',
   'has-access-to-system-mails' : 'hat-Zugriff-auf-System-Mails',

   'Custom Roles' : 'Benutzerdefinierte Rollen',
   'Custom Role' : 'Benutzerdefinierte Rolle',
   'Custom Role Name' : 'Benutzerdefinierter Rollenname',
   'Permissions' : 'Berechtigungen',
   'Add Custom Role' : 'Benutzerdefinierte Rolle hinzufügen',
   'Edit Custom Role' : 'Benutzerdefinierte Rolle bearbeiten',
   'Custom Role name' : 'Benutzerdefinierter Rollenname',
   'Permission Labels' : 'Berechtigungsetiketten',
   'Select Permission' : 'Wählen Sie Berechtigung aus',
   'Custom Role Name is required' : 'Benutzerdefinierter Rollenname ist erforderlich',


 /****************** User Details *************/

   'User Details' : 'Benutzerdetails',
   'Full Name' : 'Vollständiger Name',
   'E-Mail' : 'Email',
   'Phone' : 'Telefon',
   'Status Details' : 'Statusdetails',
   'Subscribed Courses Details' : 'Einzelheiten zu abonnierten Kursen',
   'Join Date' : 'Beitrittsdatum',
   'Last Login' : 'Letzte Anmeldung',

    /****************** New Dashboard *************/

    'Welcome' : 'Willkommen',
    'Continue Learning' : 'Lernen Sie weiter',
   'Users Logged In' : 'Benutzer angemeldet',
   'Last Logged In' : 'Zuletzt eingeloggt',
   'Last Session' : 'Letzte Sitzung',
   'The day you last logged in' : 'Der Tag, an dem Sie sich zuletzt angemeldet haben',
   'Courses that you have subscribed to' : 'Kurse, die Sie abonniert haben',
   'Number of documents expired. Please update your documents' : 'Anzahl der abgelaufenen Dokumente. Bitte aktualisieren Sie Ihre Unterlagen',
   'Last Courses Visited' : 'Zuletzt besuchte Kurse',
   'Not Logged' : 'Nicht protokolliert',

 /****************** New Courses *************/
   'Course Details' : 'Kursdetails',
   'Resume Learning' : 'Lernen fortsetzen',
   'Your have already taken the daily quiz' : 'Sie haben bereits am täglichen Quiz teilgenommen',
   'Ends' : 'Endet',

   /****************** Messages *************/
   'Messages' : 'Mitteilungen',
   'Date' : 'Datum',
   'Read' : 'Lesen',
   'Unread' : 'Ungelesen',

  /****************** Additional Pages *************/
   'Resources' : 'Ressourcen',
   'Resource Id' : 'Ressourcen-ID',
   'Resource Type' : 'Ressourcentyp',
   'File' : 'Datei',
   'Add Resources' : 'Ressourcen hinzufügen',
   'Resource Name' : 'Ressourcenname',
   'Image Upload' : 'Bild hochladen',
   'Video Resource Link' : 'Video-Ressourcen-Link',
   'Additional Pages' : 'Zusätzliche Seiten',
   'Additional Pages - Resources' : 'Zusätzliche Seiten - Ressourcen',
   'Page Id' : 'Seiten-ID',
   'Page Name' : 'Seitenname',
   'Page Name in English' : 'Seitenname auf Englisch',
   'Page Name in German' : 'Seitenname auf Deutsch',
   '*Changes will reflect only after you logout' : '*Änderungen werden erst wirksam, nachdem Sie sich abgemeldet haben',
   'Page Type' : 'Seitentyp',
   'Blank Page' : 'Unformatierte Seite',
   'Glossary Page' : 'Glossar Seite',
   'FAQ Page' : 'FAQ-Seite',
   'Display on Side Menu?' : 'Anzeige im Seitenmenü?',
   'Title in English' : 'Titel auf English',
   'Title in German' : 'Titel auf Deutsch',
   'Page Contents in English' : 'Seiteninhalt in English',  
   'Page Contents in German' : 'Seiteninhalt in Deutsch',  
   'Glossary Term in English' : 'Glossar Begriff auf Englisch',
   'Glossary Term in German' : 'Glossar Begriff auf Deutsch',
   'Definition in English' : 'Definition auf Englisch',
   'Definition in German' : 'Definition auf Deutsch',
   'Faq Question in English' : 'FAQ-Frage auf Englisch',
   'Faq Question in German' : 'FAQ-Frage auf Deutsch',
   'Answer in English' : 'Antwort in Englisch',
   'Answer in German' : 'Antwort in Deutsch',
   'Attach Resource' : 'Ressource anhängen',
   'Add Resource' : 'Ressource hinzufügen',
   'New Resource' : 'Neue Ressource',   
   'Page name is required' : 'Seitenname ist erforderlich',
   'Page Type is required' : 'Seitentyp ist erforderlich',
   'Resource Type is required' : 'Ressourcentyp ist erforderlich',
   'You cannot add more than 15 templates' : 'Sie können nicht mehr als 15 Vorlagen hinzufügen',
   'Image Resources fetched' : 'Bildressourcen verfügbar',
   'Select Resource' : 'Wählen Sie Ressource aus',
   'Please check if you have filled Page Names in all Languages and filled in at least one Title and Page content for respective Language.' : 'Bitte überprüfen Sie, ob Sie Seitennamen in allen Sprachen und mindestens einen Titel und Seiteninhalt für die jeweilige Sprache eingegeben haben.',
   'You need to fill Page Names in all Languages.' : 'Sie müssen Seitennamen in allen Sprachen eingeben.',
   'You need to fill the at least one language, Title and Page Contents' : 'Sie müssen mindestens eine Sprache, einen Titel und einen Seiteninhalt angeben',
   'faq' : 'FAQ-Seite',
   'glossary' : 'Glossar Seite',
   'blank' : 'Unformatierte Seite',

   /****************** Survey *************/
   "Survey" : "Umfrage",
   "Surveys" : "Umfragen",
   "Take Survey" : "Umfrage",
   "No Survey Found for this Course!" : "Für diesen Kurs wurde keine Umfrage gefunden!",
   "This survey is already taken. Thank you for your feedback!" : "Diese Umfrage wurde bereits durchgeführt. Danke für Ihre Rückmeldung!",
   'Survey was submitted successfully!' : 'Die Umfrage wurde erfolgreich eingereicht!',

   'Take Test' : 'Am Test teilnehmen',
   'You need to pass a module before taking test!' : 'Sie müssen ein Modul bestehen, bevor Sie an der Prüfung teilnehmen können!',
   'You already passed test!' : 'Sie haben die Prüfung bereits bestanden!',
   'If you want to check your test history, Click here' : 'Wenn Sie Ihren Testverlauf überprüfen möchten, klicken Sie hier',
   'Jump to Test Center' : 'Springen Sie zum Testcenter',
   'Please wait until the timeout is over.' : 'Bitte warten Sie, bis die Zeitüberschreitung abgelaufen ist.',
   'Test is already running!' : 'Test läuft bereits!',
   'Invalid input!' : 'Ungültige Eingabe!',
   'Test Instruction 1' : 'Alle Antworten sind zwingend erforderlich, um die maximale Punktzahl zu erreichen.',
   'Test Instruction 2' : 'Die Dauer für diesen Test beträgt ',
   ' Minutes' : ' Protokoll',
   'Test Instruction 3' : 'Der Prozentsatz des Bestehens beträgt ',
   'Test Instruction 4' : 'Sie müssen warten ',
   'Test Instruction 5' : ' minuten, um den etst erneut zu absolvieren, wenn Sie den Test nicht bestehen',
   'Test Instruction 6' : ' Für diesen Test gibt es keine zeitliche Begrenzung',
   'Test Instruction 7' : ' Für diesen Test gibt es keine Zeitüberschreitung',
   'Test History' : 'Testverlauf',
   'Attempt' : 'Versuchen',
   'Test Taken on' : 'Test durchgeführt',
   'Scored Percentage' : 'Erzielter Prozentsatz',
   'Test Name' : 'Testname',

   'Test-center' : 'Testzentrum',
   'Test Center' : 'Testzentrum',
   'Test Results' : 'Testergebnisse',
   'PASSED' : 'BESTANDEN',
   'FAILED' : 'NICHT BESTANDEN',

   //Exams
   'Exam' : 'Prüfung',
   'Exams' : 'Prüfungen',
   'Exam Ready' : 'Prüfung bereit',
   'Take Exam' : 'Absolvieren',
   'Exam Taken on' : 'Prüfung abgelegt',
   'Exam History' : 'Prüfungsverlauf',
   'If you want to check history, Click here' : 'Wenn Sie den Verlauf überprüfen möchten, klicken Sie hier',
   'Reply' : 'Antwort',
   'Exam Results' : 'Prüfungsergebnisse',
   'Exam Name' : 'Prüfungsname',

   //Exercise
   'Exercise' : 'Übung',
   'Exercises' : 'Übungen',
   'Download Exercise' : 'Übung herunterladen',
   'Download Exercise Question' : 'Übungsfrage herunterladen',
   'Close & come back later' : 'Schließen & später wiederkommen',
   'Upload Exercise Answer' : 'Übungsantwort hochladen',
   'You have already uploaded the exercise. You will receive results once a examiner grades your exercise' : 'Sie haben die Übung bereits hochgeladen. Sie erhalten die Ergebnisse, sobald ein Prüfer Ihre Übung benotet',
   'Pending Exercise' : 'Ausstehende Übung',
   'Uploaded By User' : 'Vom Benutzer hochgeladen',
   'Course Expires on' : 'Der Kurs endet am',
   'Grade' : 'Grad',
   'File Uploaded' : 'Datei hochgeladen',
   'Pending Exercises (Mandatory)' : 'Pflichtaufgaben',
   'Pending Exercises (Training)' : 'Übungsaufgaben',
   'Comments' : 'Kommentare',
   'Please enter your comments' : 'Bitte geben Sie Ihre Kommentare ein',
   'FAIL' : 'SCHEITERN',
   'PASS' : 'PASSIEREN',
   'Uploaded Answers' : 'Hochgeladene Antworten',
   'No comments added' : 'Keine Kommentare hinzugefügt',
   'Not yet graded' : 'Noch nicht benotet',
   'Next' : 'Nächste',
   'Comment' : 'Kommentar',
   'This Exercise is already graded' : 'Diese Übung ist bereits benotet',
   '*You ( ' : '*Sie ( ',
   ') are grading this exercise as ' : ') bewerten diese Übung mit ',
   'Exercise was graded successfully!' : 'Übung wurde erfolgreich bewertet!',
   'Close / Grade later' : 'Später schließen/bewerten',
   'Exercise Results (Mandatory)' : 'Übungsergebnisse (Pflichtfeld)',
   'Exercise Results (Training)' : 'Übungsergebnisse (Training)',
   'Exercise Name' : 'Übungsname',
   'Exercise Description' : 'Übungsbeschreibung',
   'Date Last Taken' : 'Datum der letzten Aufnahme',
   'Date taken' : 'Aufnahmedatum',
   'Date graded' : 'Datum der Bewertung',
   'Graded By' : 'Bewertet von',
   'Examiner Email' : 'E-Mail des Prüfers',

   //Calendar
   'Calendar' : 'Kalender',
   'Calendars' : 'Kalender',
   'Today' : 'Heute',
   'Day' : 'Tag',
   'Week' : 'Woche',
   'Month' : 'Monat',
   '4 days' : '4 Tage',
   'You are viewing an expired event!' : 'Sie sehen eine abgelaufene Veranstaltung!',
   'ACCEPTED' : 'AKZEPTIERT',
   'DECLINED' : 'ABGELEHNT',
   'Join' : 'Verbinden',
   'Thank you for joining the event. An invitation has been send to your e-mail address.' : 'Vielen Dank, dass Sie an der Veranstaltung teilgenommen haben. Eine Einladung wurde an Ihre E-Mail-Adresse gesendet.',
   'Reload Calendar' : 'Kalender neu laden',
   'Loading Events. Please stand by...' : 'Laden von Ereignissen. Bitte stehen Sie bereit...',
   'Events' : 'Veranstaltungen',
   'Personal Calendar' : 'Persönlicher Kalender',
   'Cancel Participation' : 'Teilnahme abbrechen',
   'Add Participant limit' : 'Teilnehmerlimit hinzufügen',
   'You have joined this event. Below are details of the event.' : 'Sie haben dieser Veranstaltung beigetreten. Nachfolgend finden Sie Einzelheiten zur Veranstaltung.',
   'Register Participation' : 'Teilnahme anmelden',
   'Register Participation of Users' : 'Registrieren Sie die Teilnahme von Benutzern',
   'Upcoming Events' : 'Kommende Veranstaltungen',
   'Next Event on your calendar' : 'Nächste Veranstaltung in Ihrem Kalender',
   'Expires on:' : 'Läuft aus am:',
   'This exam is Locked. Complete all modules in the course, tests, exercises, events to unlock this exam.' : 'Diese Prüfung ist gesperrt. Schließen Sie alle Module des Kurses, Tests, Übungen und Veranstaltungen ab, um diese Prüfung freizuschalten.',

};
